import * as React from 'react'
import { Button, ButtonProps } from './Button'
import omit from '../Common/omit'
import * as st from './ConfirmButton.module.scss'
import * as cn from 'classnames'

// Based on https://code.amazon.com/packages/AmazonUIPageJS/blobs/ff011a5d061a0d6f1dd22eefd6cb32ba8f80f08a/--/src/_detect.js#L194
const isTouchDevice = () => Boolean('ontouchend' in document)

export interface ConfirmButtonProps extends ButtonProps {
  confirmMessage?: string
  onlyConfirmOnTouchDevices?: boolean
}

interface ConfirmButtonState {
  shouldConfirm: boolean
}

export class ConfirmButton extends React.Component<ConfirmButtonProps, ConfirmButtonState> {

  displayName = 'ConfirmButton'
  outsideButtonBind: EventListenerOrEventListenerObject
  setButtonRef: Function
  onClickBind: Function
  buttonElement?: HTMLElement

  constructor(props: ConfirmButtonProps) {
    super(props)
    this.setButtonRef = (elem: HTMLElement) => {
      this.buttonElement = elem
    }
    this.outsideButtonBind = this.outsideButton.bind(this)
    this.state = {
      shouldConfirm: false
    }
    this.onClickBind = this.onClick.bind(this)
  }

  outsideButton(event: Event) {
    if (this.buttonElement && !this.buttonElement.contains(event.target as Node)) {
      this.setState({
        shouldConfirm: false
      })
      document.removeEventListener('click', this.outsideButtonBind)
    }
  }

  onClick(e: Event) {
    if (this.state.shouldConfirm || (this.props.onlyConfirmOnTouchDevices && !isTouchDevice())) {

      if (this.props.onClick) {
        this.props.onClick(e)
      }
      this.setState({
        shouldConfirm: false
      })
    } else {
      if (e) {
        e.preventDefault()
      }
      document.addEventListener('click', this.outsideButtonBind)
      this.setState({
        shouldConfirm: true
      })
    }
  }

  render() {
    const className = cn({ [st.confirm]: this.state.shouldConfirm, [this.props.className!]: Boolean(this.props.className) })
    const newProps = omit(
      Object.assign({}, this.props, {
        onClick: this.onClickBind,
        buttonRef: this.setButtonRef.bind(this),
        ...(className && { className })
      }),
      ['confirmMessage', 'confirm', 'onlyConfirmOnTouchDevices']
    )
    return (
      <Button {...newProps}>
        {this.state.shouldConfirm && this.props.confirmMessage ? this.props.confirmMessage : this.props.children}
      </Button>
    )
  }
}